/**
 * @index.tsx
 *
 * @fileoverview Mobile filters.
 */
import React from 'react';
import { Facet } from '~/jobiqo/models/search';
import { FacetFilterButtons } from '../../filters';

export interface DesktopFiltersProps {
  querystring: any;
  pathname: string;
  facets: Facet[];
  onFacetToggle: (
    name: string,
    selectedItems: string[],
    alias?: string,
  ) => void;
  getFacetSelectedItems(facet: Facet): string[];
  renderAdditionalFilters?: () => React.ReactNode;
}

export const DesktopFilters = ({
  pathname,
  facets,
  querystring,
  onFacetToggle,
  getFacetSelectedItems,
  renderAdditionalFilters,
}: DesktopFiltersProps) => {
  return (
    <div className="facets">
      <FacetFilterButtons
        pathname={pathname}
        querystring={querystring}
        facets={facets}
        onFacetToggle={onFacetToggle}
        getFacetSelectedItems={getFacetSelectedItems}
        renderAdditionalFilters={renderAdditionalFilters}
      />
    </div>
  );
};
export default DesktopFilters;
